import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { deleteEntry } from "../../../redux/actions/blogActions";
import CONSTANTS from "../../../misc/constants";
import moment from "moment";
import styled from "styled-components";
import Modal from "../../utils/Modal";
import { useDispatch, useSelector } from "react-redux";

const EntriesTable = ({ data }) => {
  const { page } = useParams();
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [selectedTitle, setSelectedTitle] = useState("");
  const firstRender = useRef(true);
  const setPageSize = 10;
  const pageSize = setPageSize + 1;
  const langCode = useSelector((store) => store.options.lang.code);

  const dispatch = useDispatch();

  useEffect(() => {
    if (firstRender.current) {
      document.title = `${CONSTANTS.APP_NAME} | Blog`;
      firstRender.current = false;
    }
  }, [page, pageSize]);

  const handleModal = (id, title) => {
    setSelectedId(id);
    setSelectedTitle(title);
    setModalOpen(true);
  };

  const handleDelete = (id) => {
    dispatch(deleteEntry(id));
    setModalOpen(false);
  };
  return (
    <EntriesListContainer>
      <div className="entries-container">
        <table>
          <thead>
            <tr>
              <th style={{ width: "24px" }}></th>
              <th>Title</th>
              <th>Type</th>
              <th>Date</th>
              <th>Updated</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.map((element, i) => {
              const { key, value } = element;

              let displayedLang = "esp";
              if (value.content[langCode]) {
                displayedLang = langCode;
              } else {
                if (langCode === "esp") {
                  displayedLang = "en";
                } else if (langCode === "en") {
                  displayedLang = "esp";
                }
              }

              return (
                <tr key={key}>
                  <td style={{ width: "24px" }}>
                    <Link
                      className="btn action-btn"
                      to={`/entry/${value.slug}`}
                    >
                      <i className="far fa-eye"></i>
                    </Link>
                  </td>
                  <td>{value.content[displayedLang].title}</td>
                  <td>{value.entryType}</td>
                  <td>
                    {moment(value.meta.creationDate * -1).format(
                      "MM/D/YY H:mm"
                    )}
                  </td>
                  <td>
                    {value.meta.updateDate
                      ? moment(value.meta.updateDate * -1).format(
                          "MM/D/YY H:mm"
                        )
                      : "N/A"}
                  </td>
                  <td>
                    <Link className="btn action-btn" to={`/edit-entry/${key}`}>
                      <i className="fas fa-edit"></i>
                    </Link>
                    <button
                      className="btn action-btn"
                      onClick={() => handleModal(key, value.content.title)}
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <Modal open={modalOpen} toggleHandler={setModalOpen}>
          <div>
            <h4>
              Do you really want to delete <strong>"{selectedTitle}"</strong>?
            </h4>
          </div>
          <div>
            <button onClick={() => handleDelete(selectedId)}>Yes</button>{" "}
            <button onClick={() => setModalOpen(false)}>No</button>
          </div>
        </Modal>
      </div>
    </EntriesListContainer>
  );
};

const EntriesListContainer = styled.div`
  .column {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export default EntriesTable;
